<template>
  <el-dialog
    title="物流信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      size="small"
    >
      <el-form-item
        label="商铺名称"
      >
        {{agentname}}
      </el-form-item>
      <el-form-item
        label="支付金额(元)"
      >
        {{amount}}
      </el-form-item>
      <el-form-item
              label="订单号"
      >
        {{order_id}}
      </el-form-item>
      <el-form-item
              label="商品名称"
      >
        {{order_content}}
      </el-form-item>

      <el-form-item
              label="商品图片"
      >

        <div v-if="good_url!=null && good_url!=''">


          <span v-for="item in this.good_url.split(',')">

               <span v-if="item.indexOf('mp4') !=-1">
              <video
                      v-bind:src="getImgUrl(item)"
                      class="avatar video-avatar"
                      controls="controls"  style="width: 200px;height: 200px; "></video><br/>
              </span>
              <span v-else>
                 <img :src= "getImgUrl(item)"  @click="previewPic(item)"  style="width: 100px;height: 100px;  "/><br/>
              </span>


              </span>


        </div>
      </el-form-item>
      <el-form-item
              label="下单时间"
      >
        {{insert_time2}}
      </el-form-item>
      <div v-if="type_video=='0'">
      <el-form-item
              label="收货人"
      >
        {{consignee}}
      </el-form-item>
      <el-form-item
              label="收货人电话"
      >
        {{consignee_tel}}
      </el-form-item>
      <el-form-item
              label="收货地址"
      >
        {{province_address}}{{consignee_address}}
      </el-form-item>
        <el-form-item
                label="快递名称"
        >
          {{express_name}}
        </el-form-item>
        <el-form-item
                label="快递号"
        >
          {{express_no}}            <el-button type="primary" plain size="mini"    @click="aaaa()">查看快递进度</el-button>
        </el-form-item>
      </div>


    </el-form>

     <!-- 图片预览 -->

          <el-dialog :visible.sync="dialogVisible2" :modal="false" title="图片预览" width="50%">

            <img :src="previewpic" alt=""  width="100%" />

            <span slot="footer" class="dialog-footer">

              <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>

            </span>

          </el-dialog>

      <!-- 图片预览 -->

  </el-dialog>

</template>
<script>
    import * as oneclassService from "@/api/sys/oneclass";
    import util from '@/libs/util.js'
export default {
  name: "oneclassEditForm",
  props: {
      oneclass: Object,
    value: Boolean
  },
  data() {
    return {
        formEdit: true,
      loading: false,
      dialogVisible2: false,

      previewpic: "",
      dialogVisible: false,
        agentname:"",
      type_video:"",
      amount:"",
      order_id:"",
      order_content:"",
      good_url:"",
      insert_time2:"",
      consignee:"",
      consignee_tel:"",
      consignee_address:"",
      province_address:"",
      express_name:"",
      express_no:"",
      form: {

      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
        let form = {};
        this.form = form;
      if (this.oneclass.id) {
       // userService.getUser(this.user.id).then(data => {
        this.type_video=this.oneclass.type_video;
          this.agentname=this.oneclass.agent_name;
        this.amount=this.oneclass.amount;
        this.order_id=this.oneclass.order_id;
        this.order_content=this.oneclass.order_content;
              this.good_url=this.oneclass.good_url;
              this.insert_time2=this.oneclass.insert_time2;
        this.express_name=this.oneclass.express_name;
                this.express_no=this.oneclass.express_no;
        this.consignee=this.oneclass.consignee;
        this.consignee_tel=this.oneclass.consignee_tel;
        this.consignee_address=this.oneclass.consignee_address;
        this.province_address=this.oneclass.province_address;





          this.formEdit = true;
      }
    },
    aaaa(){
      window.open("https://www.kuaidi100.com/","_blank");
    },
      getImgUrl(good_url){
        /**var good_url=this.good_url;
        if(good_url.match(",")){
          var str = good_url.split(',');
          good_url=str[1];
        }**/

        return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+good_url;
      },

    previewPic(good_url) {
      this.previewpic ="https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+good_url;

      this.dialogVisible2 = true;

    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

